const FeedbackConst = {
    START_TIMER: "START_TIMER",
    START_DOWNLOAD: "START_DOWNLOAD",
    RESULT_DOWNLOAD_FINISHED: "RESULT_DOWNLOAD_FINISHED",
    START_REQUESTS: "START_REQUESTS"
};

export default FeedbackConst;


// WEBPACK FOOTER //
// ./src/modules/feedback/FeedbackConst.js